import { createSelector } from 'reselect';

const selectEApplicationSettings = (state: any) => state.eApplicationSettings;


export const selectEApplicationSettingsCurrentItem = createSelector([selectEApplicationSettings], (eApplicationSettings) => eApplicationSettings.current);

export const selectEApplicationSettingsListItems = createSelector([selectEApplicationSettings], (eApplicationSettings) => eApplicationSettings.list);

export const selectEApplicationSettingsItemById = (itemId: any) =>
    createSelector(selectEApplicationSettingsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectEApplicationSettingsQueryItems = createSelector([selectEApplicationSettings], (eApplicationSettings) => eApplicationSettings.query);

export const selectEApplicationSettingsCreatedItem = createSelector([selectEApplicationSettings], (eApplicationSettings) => eApplicationSettings.create);

export const selectEApplicationSettingsUpdatedItem = createSelector([selectEApplicationSettings], (eApplicationSettings) => eApplicationSettings.update);

export const selectEApplicationSettingsReadItem = createSelector([selectEApplicationSettings], (eApplicationSettings) => eApplicationSettings.read);

export const selectEApplicationSettingsDeletedItem = createSelector([selectEApplicationSettings], (eApplicationSettings) => eApplicationSettings.delete);

export const selectEApplicationSettingsSearchedItems = createSelector([selectEApplicationSettings], (eApplicationSettings) => eApplicationSettings.search);

export const selectEApplicationSettingsItemsCount = createSelector([selectEApplicationSettings], (eApplicationSettings) => eApplicationSettings.count);

export const selectEApplicationSettingsItemsFilter = createSelector([selectEApplicationSettings], (eApplicationSettings) => eApplicationSettings.filter);